import type { Product, Transaction } from '@avalara/types/analytics';

type TrackProps = {
  eventName: string;
  eventType: string;
  product?: Array<Product>;
  transaction?: Transaction;
};

/* NOTE(Sasha): This function will take in various data objects based on Adobe
   Analytics digitalData obj. Each object should contain relevant info that
   corresponds to the data being tracked. Ex: Tracking a purchase event should
   include a product object and a transaction object that detail the productId,
   quantity, price, eventType, eventName and any other items worth tracking.
   Events are tracked by action and sent through _satellite. */
export const trackEvent = ({ product, eventName, transaction, eventType }: TrackProps) => {
  if (window.digitalData) {
    window.digitalData = {
      ...window.digitalData,
      product,
      transaction,
      event: {
        eventInfo: {
          eventName,
        },
      },
    };
  }
  if (window._satellite && typeof window._satellite.track === 'function') {
    window._satellite.track(eventType);
  }
};
